import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

export async function fetchNfeHeaders(filters = {}) {
  const url = new URL("/nfe_header", API_BASE_URL);

  if (filters.accessKey?.trim()) {
    url.searchParams.set("accesskey", filters.accessKey.trim());
  }

  if (filters.supplier_cnpj?.trim()) {
    url.searchParams.set("supplier_cnpj", filters.supplier_cnpj.trim());
  }

  if (filters.plant?.trim()) {
    url.searchParams.set("plant", filters.plant.trim());
  }


  if (filters.process?.length) {
    filters.process.forEach((p) => {
      url.searchParams.append("process", String(p));
    });
  }

if (filters.step?.length) {
  filters.step.forEach((s) => {
    url.searchParams.append("step", String(s));
  });
}

  if (filters.issueDateFrom) {
    url.searchParams.set("issue_date_from", filters.issueDateFrom);
  }

  if (filters.issueDateTo) {
    url.searchParams.set("issue_date_to", filters.issueDateTo);
  }

  if (filters.receivedDateFrom) {
    url.searchParams.set("received_date_from", filters.receivedDateFrom);
  }

  if (filters.receivedDateTo) {
    url.searchParams.set("received_date_to", filters.receivedDateTo);
  }

  const response = await fetch(url.toString());
  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Servidor indisponível. Verifique a conexão com o backend.");
  }

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao buscar notas fiscais"));
  }

  return data;
}